export const LIGHT_BG_TITLE_COLOR = "#111827";
export const DARK_BG_TITLE_COLOR = "#FFFFFF";

const DARK_TITLE_LUMA = 190;
const SAMPLE_WIDTH = 240;


const HEADING_ZONE = {
  desktop: { x1: 0.48, y0OfWidth: 0.028, y1OfWidth: 0.125 },
  mobile: { x1: 0.65, y0OfHeight: 0.024, y1OfHeight: 0.122 },
};

export const getAutoTitleColor = (img, { compact = false } = {}) => {
  try {
    const { naturalWidth, naturalHeight } = img || {};
    if (!naturalWidth || !naturalHeight) return null;

    const scale = Math.min(1, SAMPLE_WIDTH / naturalWidth);
    const width = Math.max(1, Math.round(naturalWidth * scale));
    const height = Math.max(1, Math.round(naturalHeight * scale));

    let x1;
    let y0;
    let y1;
    if (compact) {
      const zone = HEADING_ZONE.mobile;
      x1 = width * zone.x1;
      y0 = height * zone.y0OfHeight;
      y1 = height * zone.y1OfHeight;
    } else {
      const zone = HEADING_ZONE.desktop;
      x1 = width * zone.x1;
      y0 = Math.min(height - 1, width * zone.y0OfWidth);
      y1 = Math.min(height, width * zone.y1OfWidth);
    }
    const zoneX = 0;
    const zoneY = Math.floor(y0);
    const zoneW = Math.max(1, Math.round(x1));
    const zoneH = Math.max(1, Math.round(y1) - zoneY);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) return null;
    context.drawImage(img, 0, 0, width, height);
    // Throws a SecurityError when the image was not loaded with CORS.
    const { data } = context.getImageData(zoneX, zoneY, zoneW, zoneH);

    let lumaSum = 0;
    let count = 0;
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 128) continue; // skip transparent pixels
      lumaSum += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
      count += 1;
    }
    if (!count) return null;

    return lumaSum / count >= DARK_TITLE_LUMA
      ? LIGHT_BG_TITLE_COLOR
      : DARK_BG_TITLE_COLOR;
  } catch (error) {
    return null;
  }
};
